'use client'

import ErrorPlaceholder from './[lang]/components/ErrorPlaceholder'

export default function Error({ error }) {
  return <ErrorPlaceholder error={error} />
}
